import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { WHATSAPP_URL } from '../utils/whatsapp';

function ContactSection() {
  return (
    <section className="contact" id="contact">
      <div className="contact-card">
        <span className="eyebrow">10 / The beginning of something beautiful</span>
        <h2>Let’s make<br /><em>something lasting.</em></h2>
        <p>The best stories start with a hello. Message us on WhatsApp and we’ll take it from there.</p>
        <a
          className="contact-link"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <SafeIcon icon={FaWhatsapp} /> Contact Us
        </a>
        <span className="contact-note">Now booking 2026 & 2027 celebrations</span>
      </div>
    </section>
  );
}

export default ContactSection;
